export default __webpack_public_path__ + "static/bong-bong-33fe180d3367e4325e8ba73a98d40599.png";